import React from 'react';
import useUser from '../../../../../../hooks/useUser';

export default function WhoAmI() {
  const user = useUser();

  return (
    <div className="who-am-i-wrapper">
      <div className="who-am-i-full-name">{user.getFullName()},</div>
      <div className="who-am-i-role">
        <b>{user.getRoleLabel()}</b>
      </div>
      {/* Render additional user data only for not admin and user with hcp */}
      {user.facility && user.workgroup && (
        <>
          <div className="who-am-i-structure-workgroup">{`${user.facility?.name || '-'} - ${
            user.workgroup?.name || '-'
          }`}</div>
        </>
      )}
      {user.lhc && (
        <>
          <div className="who-am-i-lhc">{user.lhc?.name || '-'}</div>
        </>
      )}
    </div>
  );
}
